import { ClientError } from "graphql-request";
import { GetStaticPropsContext, GetStaticPropsResult, NextPage } from "next";

import PageHead, { TwitterCard } from "~/components/common/PageHead";
import { Form } from "~/components/database/detail/database-content/types";
import Page from "~/components/database/page/[id]/database-detail-page";
import { logger } from "~/components/newrelic/Logger";
import { Layout } from "~/lib/client/layout";
import { createGraphqlClient } from "~/lib/graphql/graphqlClient";

export type DatabaseDetailPageProps = {
  form: Form;
};

export async function getServerSideProps(
  context: GetStaticPropsContext
): Promise<GetStaticPropsResult<DatabaseDetailPageProps>> {
  const formId = context.params?.id;

  if (typeof formId !== "string" || !formId.match(/^[0-9]+$/)) {
    return {
      notFound: true,
    };
  }
  const client = createGraphqlClient();
  return await client
    .databaseDetailContent({ id: Number(formId) })
    .then(({ form }) => {
      const questions = form.questions.sort((a, b) => a.position - b.position);
      return { props: { form: { ...form, questions } } };
    })
    .catch((e) => {
      if (e instanceof ClientError) {
        console.error(`error: ${e.message}`);
        logger.error(e);
        return { notFound: true };
      }

      return {
        notFound: true,
      };
    });
}

const DatabaseDetailPage: NextPage<DatabaseDetailPageProps> = (props) => {
  const twitterCardParams = new URLSearchParams({
    title: props.form.title,
    author: props.form.user.name,
    categories: props.form.categories
      .map((category) => category.name)
      .join(","),
  }).toString();

  const twitterCard: TwitterCard = {
    cardType: "summary_large_image",
    creator: props.form.user.name,
    ogImage: `https://www.fussy.fun/api/og/database?${twitterCardParams}`,
  };

  const headProps = { title: `${props.form.title} | FUSSY`, twitterCard };

  return (
    <>
      <PageHead {...headProps} />
      <Layout layoutType={"YTLayout"}>
        <Page form={props.form} />
      </Layout>
    </>
  );
};

export default DatabaseDetailPage;
